import { useField, useFormikContext } from "formik";
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { formatDateFieldValue } from "../../helpers/dateHelpers";
import { useString } from "../../localization/localizationHelpers";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import * as styles from "./DatePickerField.module.css";

type DatePickerFieldProps = Readonly<{
  name: string;
  disabled?: boolean;
  parentChecked?: boolean;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const DatePickerField = (props: DatePickerFieldProps) => {
  const { name, isSaving, parentChecked } = props;
  const targetPlatformsReleaseDateTitle = useString("targetPlatformsReleaseDateTitle");
  const [dateField, _dateFieldMeta, dateFieldHelpers] = useField({
    name,
  });
  const { setValue, setTouched } = dateFieldHelpers;
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (parentChecked === false && dateField.value !== "") {
      setFieldValue(dateField.name, "");
    }
  }, [dateField.value, parentChecked, setFieldValue, dateField.name]);

  return (
    <Row className={commonStyles.slimContainer}>
      <Column>
        <div>
          <FieldHeader {...props} />
          <>
            <Row>
              <Column>
                <div className={styles.flex}>
                  <DatePicker
                    data-testid={dateField.name}
                    disabled={isSaving || parentChecked === false}
                    selected={
                      dateField.value ? new Date(formatDateFieldValue(dateField.value)) : undefined
                    }
                    className={styles.calendar}
                    id={dateField.name}
                    onChange={(date: Date) => {
                      setValue(date.toLocaleDateString("en-US"));
                      setTouched(true);
                    }}
                    placeholderText={targetPlatformsReleaseDateTitle}
                  />
                </div>
              </Column>
            </Row>
            <FieldErrorMessage fieldName={dateField.name} />
          </>
        </div>
      </Column>
    </Row>
  );
};
